import { commonService } from '../../_services'
const service = commonService('api/v1/admin/operator')

export const operators = {
  namespaced: true,
  state: {
    all: { items: [] },
    loading: false,
  },
  actions: {
    async getAll(context: any): Promise<void> {
      context.commit('GET_ALL_REQUEST')
      return service.getAll().then((resp) => {
        context.commit('GET_ALL_SUCCESS', resp.data)
        return Promise.resolve(resp.data)
      }).catch(errorMsg => {
        context.commit('GET_ALL_FAILURE')
        context.dispatch('common/setFlashMessage', { error: [errorMsg] }, { root: true })
      })
    },
    async addOne(context: any, data: any): Promise<void> {
      context.commit('ADD_REQUEST')

      return service.addOne(data).then((resp) => {
        // Fetch just added data
        service.getOne(resp.data._id).then(singleData => {
          context.commit('ADD_ITEM_SUCCESS', singleData.data)
        })
        return Promise.resolve(resp.data)
      }).catch(errorMsg => {
        context.commit('REQUEST_ERROR')
        context.dispatch('common/setFlashMessage', { error: [errorMsg] }, { root: true })
        return Promise.reject(errorMsg)
      })
    },
    async updateOne(context: any, data: any): Promise<void> {
      context.commit('UPDATE_REQUEST')

      return service.updateOne(data).then((resp) => {
        return service.getOne(resp.data._id).then(singleData => {
          context.commit('UPDATE_ITEM_SUCCESS', singleData.data)
          return Promise.resolve(singleData.data)
        })
      }).catch(errorMsg => {
        context.commit('REQUEST_ERROR')
        context.dispatch('common/setFlashMessage', { error: [errorMsg] }, { root: true })
        return Promise.reject(errorMsg)
      })
    },
    async deleteOne(context: any, data: any): Promise<void> {
      context.commit('DELETE_REQUEST')

      return service.deleteOne(data._id).then((resp) => {
        context.commit('DELETE_ITEM_SUCCESS', data)
        return Promise.resolve(resp.data)
      }).catch(errorMsg => {
        context.commit('REQUEST_ERROR')
        context.dispatch('common/setFlashMessage', { error: [errorMsg] }, { root: true })
        return Promise.reject(errorMsg)
      })
    },
    async hasRefs(context: any, data: any): Promise<void> {
      context.commit('GET_REQUEST')
      return service.hasRefs(data._id).then((resp) => {
        context.commit('GET_REQUEST_SUCCESS', resp.data)
        return Promise.resolve(resp.data)
      }).catch(errorMsg => {
        context.commit('REQUEST_ERROR')
        context.dispatch('common/setFlashMessage', { error: [errorMsg] }, { root: true })
      })
    },
  },
  mutations: {
    GET_ALL_REQUEST(state: any) {
      state.loading = true
    },
    GET_ALL_SUCCESS(state: any, allItems: any[]) {
      allItems.map(item => {
        return item
      })

      state.all = { items: allItems }
      state.loading = false
    },
    GET_ALL_FAILURE(state: any) {
      state.all = { items: [] }
      state.loading = false
    },
    GET_REQUEST(state: any) {
      state.loading = true
    },
    GET_REQUEST_SUCCESS(state: any) {
      state.loading = false
    },
    ADD_REQUEST(state: any) {
      state.loading = true
    },
    UPDATE_REQUEST(state: any) {
      state.loading = true
    },
    DELETE_REQUEST(state: any) {
      state.loading = true
    },
    ADD_ITEM_SUCCESS(state: any, item: any) {
      state.all.items.push(item)
      state.loading = false
    },
    UPDATE_ITEM_SUCCESS(state: any, item: any) {
      state.all.items = state.all.items.map(tmp => {
        return tmp._id === item._id ? item : tmp
      })

      state.loading = false
    },
    DELETE_ITEM_SUCCESS(state: any, item: any) {
      const index = state.all.items.indexOf(item)
      state.all.items.splice(index, 1)
      state.loading = false
    },
    REQUEST_ERROR(state: any, error: any) {
      state.loading = false
    }
  },
  getters: {
    canEdit: state => () => {
      return service.canEdit()
    },
    canDelete: state => () => {
      return service.canDelete()
    }
  },
}
